import React from 'react';
import { DashboardLayout } from '@/shared/layout/DashboardLayout';
import { Card } from '@/components/ui';

export default function DirectorDashboardPage() {
  return (
    <DashboardLayout
      title="Dashboard Ban Giám đốc"
      breadcrumbs={[{ label: 'Dashboard', href: '/dashboard' }, { label: 'Director' }]}
    >
      <Card className="p-20 flex flex-col items-center justify-center border-dashed border-2 border-slate-200 bg-slate-50/50">
        <div className="w-16 h-16 rounded-full bg-os-primary/10 flex items-center justify-center mb-4">
          <i className="ri-tools-line text-2xl text-os-primary" />
        </div>
        <h2 className="text-xl font-bold text-slate-800">Trang đang trong quá trình thiết kế</h2>
        <p className="text-slate-500 mt-2">Tính năng dành cho Ban Giám đốc sẽ sớm được cập nhật.</p>
      </Card>
    </DashboardLayout>
  );
}
